import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { CreditsService } from 'src/@core/services/credits/credits.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { environment } from 'src/environments/environment';
declare var Razorpay: any;

@Component({
  selector: 'hour4u-admin-pay-bill',
  templateUrl: './pay-bill.component.html',
  styleUrls: ['./pay-bill.component.scss']
})
export class PayBillComponent implements OnInit {
  isLoading: boolean = false;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  paymentMode: string = "Via Credit wallet";
  paymentMethods: any[] = [
    {
      name: 'Via Credit wallet',
      type: 'Via Credit wallet'
    },
    {
      name: 'Via Payment gateway',
      type: 'Via Payment gateway'
    }
  ];
  walletBalance: any = null;
  profile = this.appService.getCurrentAccount();

  constructor(
    public dialogRef: MatDialogRef<PayBillComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedData: any,
    private service: JobService,
    private notify: NotificationService,
    public creditsService: CreditsService,
    private appService: AppService
  ) { }

  ngOnInit() {
    console.log(this.selectedData)
    this.getCashCreditBalance();
  }

  getCashCreditBalance() {
    let entityId = this.profile.entity.id;
    this.isLoading = true;
    this.creditsService.fetchWalletBalance(entityId).subscribe(
      (response) => {
        this.isLoading = false;
        this.walletBalance = response.result;
        if (this.walletBalance && this.walletBalance.walletBalance < this.selectedData.totalAmount) {
          this.paymentMode = "Via Payment gateway";
        }
      }, (error) => {
        this.isLoading = false;
        console.error('Failed to fetch wallet balance:', error);
      })
  }

  paymentMark() {
    if (this.paymentMode == "Via Payment gateway") {
      this.payBillViaPaymentGateway();
    }

    if (this.paymentMode == "Via Credit wallet") {
      this.payBillViaCreditWallet();
    }
  }

  // pay Bill Via Payment gateway
  payBillViaPaymentGateway() {
    console.log(this.selectedData)
    this.razorPayOptions.amount = this.selectedData.totalAmount
    this.razorPayOptions.currency = 'INR';
    this.razorPayOptions.key = environment.rezorpayKey;
    this.razorPayOptions.order_id = this.selectedData.paymentDetails.razorPayOrderId;
    console.log("this.razorPayOptions", this.razorPayOptions)
    var rzp = new Razorpay(this.razorPayOptions);
    rzp.open()
    rzp.on('payment.failed', function (response) {
      console.log("response--", response)
      alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);
    });
  }

  // Payment options
  razorPayOptions = {
    "key": '',
    "amount": 0,
    "currency": '',
    "name": '',
    "discription": "Workorbit's Billing",
    "order_id": '',
    "handler": (response) => {
      console.log("response=====", response)
      this.service.updateBillingStatus(this.selectedData.id, 'PAYMENT_SUCCESS').subscribe(res => {
        this.notify.showMessage('Billing paid Via payment gateway successfully!', 2000);
        this.dialogRef.close(true);
      }, ((err: any) => {
        this.notify.showMessage(err.error.message, 2000);
      }))
    }
  };

  // pay Bill Via Credit Wallet
  payBillViaCreditWallet() {
    let obj = {
      "sourceUserId": this.profile.entity.id,
      "destinationUserId": this.selectedData.billingRaisedBy.id,
      "referenceNumber": this.selectedData.paymentDetails.razorPayOrderId,
      "orderPurpose": "",
      "amount": this.selectedData.totalAmount
    }
    console.log(obj)
    this.creditsService.paymentViaCashWallet(obj).subscribe(res => {
      this.creditsService.setRefreshCreditsHeader(true);
      this.service.updateBillingStatus(this.selectedData.id, 'PAYMENT_SUCCESS').subscribe(res => {
        this.notify.showMessage('Billing paid Via credit wallet successfully!', 2000);
        this.dialogRef.close(true);
      }, ((err: any) => {
        this.notify.showMessage(err.error.message, 2000);
      }))
    }, (err: any) => {
      this.notify.showMessage(err.error.message, 2000);
    })
  }
}
